import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
/* -----------------------------------
   CATEGORY CONFIGURATION
----------------------------------- */
const categoryConfig = {
  "general": {
    title: "General",
    badge: "gray",
    order: 1,
  },
  // confirmations: {
  //   title: "Confirmations & Reconfirmations",
  //   badge: "gray",
  //   order: 2,
  // },
  bulkUpload: {
    title: "Bulk Upload (Vendors)",
    badge: "gray",
    order: 2
  },
};

/* -----------------------------------
   VIDEOS DATA
----------------------------------- */
// const videosData = [
//   {
//     id: "delay-order",
//     title: "Delay Order",
//     description: selectedLnag === "mn" ? "延迟订单并重新安排交货日期" : "Delay orders and reschedule delivery dates",
//     placeholder: selectedLnag === "mn" ? "了解如何延迟和重新安排订单" : "Learn how to delay and reschedule an order",
//     category: "order-management",
//     keywords: "delay postpone reschedule",
//     duration: "0:48",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Delay Order.mp4"
//   },
//   {
//     id: "divert-accept",
//     title: "Divert Accept",
//     description: selectedLnag === "mn" ?"接受订单转移请求": "Accept order diversion requests",
//     placeholder: selectedLnag === "mn" ?"了解如何接受分流请求": "See how to accept a diversion request",
//     category: "order-management",
//     keywords: "divert accept redirect",
//     duration: "0:24",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Divert_Accept.mp4"
//   },
//   {
//     id: "divert-reject",
//     title: "Divert Reject",
//     description: selectedLnag === "mn" ?"拒绝订单转移请求": "Reject order diversion requests",
//     placeholder: selectedLnag === "mn" ?"学会何时以及如何拒绝诱惑": "Learn when and how to reject diversions",
//     category: "order-management",
//     keywords: "divert reject",
//     duration: "0:26",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Divert_Reject.mp4"
//   },
//   {
//     id: "expedite-accept",
//     title: "Expedite Accept",
//     description: selectedLnag === "mn"?"接受加急订单的加急处理请求":"Accept expedite requests for urgent orders",
//     placeholder: selectedLnag === "mn"?"接受加急请求":"Accept expedite requests",
//     category: "order-management",
//     keywords: "expedite accept urgent",
//     duration: "0:20",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Accept.mp4"
//   },
//   {
//     id: "expedite-propose-sw",
//     title: "Expedite Propose SW",
//     description: selectedLnag === "mn"?"接受加急请求并提出新的船舶周计划":"Accept expedite requests and propose new ship week",
//     placeholder: selectedLnag === "mn"?"接受加急请求，并于新船周发货":"Accept expedite request with new ship week",
//     category: "order-management",
//     keywords: "expedite propose new sw shipweek urgent",
//     duration: "0:44",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Propose SW.mp4"
//   },
//   {
//     id: "expedite-reject",
//     title: "Expedite Reject",
//     description: selectedLnag === "mn"?"拒绝加急订单的请求":"Reject expedite requests for urgent orders",
//     placeholder: selectedLnag === "mn"?"拒绝加急请求":"Reject expedite requests",
//     category: "order-management",
//     keywords: "expedite reject urgent",
//     duration: "0:21",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Reject.mp4"
//   },
//   {
//     id: "po-confirm-accept",
//     title: "PO Confirm Accept",
//     description: selectedLnag === "mn"?"接受采购订单确认":"Accept purchase order confirmations",
//     placeholder: selectedLnag === "mn"?"确认采购订单":"Confirm purchase order",
//     category: "confirmations",
//     keywords: "po confirm accept",
//     duration: "0:21",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm_Accept.mp4"
//   },
//   {
//     id: "po-confirm-change-price",
//     title: "PO Confirm Change Price",
//     description: selectedLnag === "mn"?"采购订单确认期间更改价格":"Change price during PO confirmation",
//     placeholder: selectedLnag === "mn"?"学习如何在采购订单确认期间更改价格":"Learn to change price during PO confirmation",
//     category: "confirmations",
//     keywords: "price change confirm",
//     duration: "0:29",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm_Change Price.mp4"
//   },
//   {
//     id: "po-confirm-change-qty",
//     title: "PO Confirm Change Qty",
//     description: selectedLnag === "mn"?"在采购订单确认期间更改数量":"Change quantity during PO confirmation",
//     placeholder: selectedLnag === "mn"?"在确认过程中修改订单数量":"Modify order quantity during confirmation",
//     category: "confirmations",
//     keywords: "quantity change confirm",
//     duration: "0:34",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm_Change Qty.mp4"
//   },
//   {
//     id: "po-confirm-change-sw",
//     title: "PO Confirm Change SW",
//     description: selectedLnag === "mn"?"在采购订单确认期间修改发货周":"Modify ship week during PO confirmation",
//     placeholder: selectedLnag === "mn"?"在采购订单确认期间更改发货周":"Change ship week during PO confirmation",
//     category: "confirmations",
//     keywords: "ship week confirm",
//     duration: "0:34",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm_Change SW.mp4"
//   },
//   {
//     id: "po-reconfirm-accept",
//     title: "PO ReConfirm Accept",
//     description: selectedLnag === "mn"?"接受采购订单重新确认请求":"Accept PO reconfirmation requests",
//     placeholder: selectedLnag === "mn"?"接受并完成采购订单复确认":"Accept and complete PO reconfirmations",
//     category: "confirmations",
//     keywords: "reconfirm accept",
//     duration: "0:15",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO ReConfirm_Accept.mp4"
//   },
//   {
//     id: "po-reconfirm-change",
//     title: "PO ReConfirm Change",
//     description: selectedLnag === "mn"?"在重新确认期间修改采购订单":"Modify PO during reconfirmation",
//     placeholder: selectedLnag === "mn"?"在采购订单重新确认期间进行更改":"Make changes during PO reconfirmation",
//     category: "confirmations",
//     keywords: "reconfirm change",
//     duration: "0:31",
//     videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO ReConfirm_Change.mp4"
//   }
// ];

/* -----------------------------------
   VIDEO MODAL
----------------------------------- */
function VideoModal({ open, videoUrl, onClose }) {

  const videoRef = useRef(null);

  useEffect(() => {
    if (!open && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center">
      <div className="relative w-[90%] max-w-5xl bg-black rounded-lg">
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-white text-3xl"
        >
          &times;
        </button>

        <div className="relative pt-[56.25%]">
          <video
            ref={videoRef}
            src={videoUrl}
            controls
            autoPlay
            className="absolute top-0 left-0 w-full h-full"
          />
        </div>
      </div>
    </div>
  );
}

/* -----------------------------------
   VIDEO CARD
----------------------------------- */
function VideoCard({ v, playVideo }) {
  const { t } = useTranslation();
  const { watchVideo } = t('trainingvideos');
  const gradient =
    v.category === "confirmations"
      ? "from-gray-400 to-gray-500"
      : "from-gray-400 to-gray-500";

  return (
    <div className="bg-white rounded-lg shadow hover:shadow-lg transition">
      <div
        className={`bg-gradient-to-br ${gradient} h-48 rounded-t-lg flex items-center justify-center relative cursor-pointer`}
        onClick={() => playVideo(v.videoUrl)}
      >
        <svg
          className="w-12 h-12 absolute top-10 text-white opacity-90"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
        </svg>

        <div className="absolute bottom-6 text-center text-white font-semibold text-2xl px-2">
          {v.placeholder}
        </div>

        <div className="absolute top-3 right-3 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
          {v.duration}
        </div>
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-gray-800 mb-2">
          {v.title}
        </h3>
        <p className="text-sm text-gray-600 mb-3">
          {v.description}
        </p>
        <button
          onClick={() => playVideo(v.videoUrl)}
          className="text-blue-600 hover:text-blue-700 font-medium text-sm"
        >
          {`${watchVideo} →`}
        </button>
      </div>
    </div>

  );
}

/* -----------------------------------
   CATEGORY SECTION
----------------------------------- */
function CategorySection({ categoryKey, videos, onPlay }) {
  const cfg = categoryConfig[categoryKey];

  return (
    <section>
      <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
        <span
          className={`bg-${cfg.badge}-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm`}
        >
          {cfg.order}
        </span>
        {cfg.title}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.map((v) => (
          <VideoCard key={v.id} v={v} playVideo={onPlay} />
        ))}
      </div>
    </section>
  );
}

/* -----------------------------------
   MAIN PAGE
----------------------------------- */
export const TrainingVideos = () => {
  const { t, i18n } = useTranslation();
  const { HelpTrainingVideos, LearnVideoGuide, AllCategories, videos, Showing, HaveQuestions, NeedHelp, AccessUserManual,
    DetailedInfo, UserManual, LookingForHelp, TrainingVideo, searchVideos
  } = t('trainingvideos');
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const [activeVideo, setActiveVideo] = useState(null);
  const videosData = useMemo(() => ([
    {
      id: "delay-order",
      title: "Delay Order",
      description: i18n.language === "mn" ? "延迟订单并重新安排交货日期" : "Delay orders and reschedule delivery dates",
      placeholder: i18n.language === "mn" ? "了解如何延迟和重新安排订单" : "Learn how to delay and reschedule an order",
      category: "general",
      keywords: "delay postpone reschedule",
      duration: "0:52",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Delay Order_Final.mp4"
    },
    {
      id: "divert-accept",
      title: "Divert Accept",
      description: i18n.language === "mn" ? "接受订单转移请求" : "Accept order diversion requests",
      placeholder: i18n.language === "mn" ? "了解如何接受分流请求" : "See how to accept a diversion request",
      category: "general",
      keywords: "divert accept redirect",
      duration: "0:28",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Divert_Accept_Final.mp4"
    },
    {
      id: "divert-reject",
      title: "Divert Reject",
      description: i18n.language === "mn" ? "拒绝订单转移请求" : "Reject order diversion requests",
      placeholder: i18n.language === "mn" ? "学会何时以及如何拒绝诱惑" : "Learn when and how to reject diversions",
      category: "general",
      keywords: "divert reject",
      duration: "0:31",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Divert_Reject_Final.mp4"
    },
    {
      id: "expedite-accept",
      title: "Expedite Accept",
      description: i18n.language === "mn" ? "接受加急订单的加急处理请求" : "Accept expedite requests for urgent orders",
      placeholder: i18n.language === "mn" ? "接受加急请求" : "Accept expedite requests",
      category: "general",
      keywords: "expedite accept urgent",
      duration: "0:24",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Accept_Final.mp4"
    },
    {
      id: "expedite-propose-sw",
      title: "Expedite Propose SW",
      description: i18n.language === "mn" ? "接受加急请求并提出新的船舶周计划" : "Accept expedite requests and propose new ship week",
      placeholder: i18n.language === "mn" ? "接受加急请求，并于新船周发货" : "Accept expedite request with new ship week",
      category: "general",
      keywords: "expedite propose new sw shipweek urgent",
      duration: "0:50",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Propose New SW_Revised.mp4"
    },
    {
      id: "expedite-reject",
      title: "Expedite Reject",
      description: i18n.language === "mn" ? "拒绝加急订单的请求" : "Reject expedite requests for urgent orders",
      placeholder: i18n.language === "mn" ? "拒绝加急请求" : "Reject expedite requests",
      category: "general",
      keywords: "expedite reject urgent",
      duration: "0:25",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Expedite_Reject_Final.mp4"
    },
    {
      id: "defer-accept",
      title: "Defer Accept",
      description: i18n.language === "mn" ? "接受推迟请求" : "Accept Defer requests",
      placeholder: i18n.language === "mn" ? "接受推迟请求" : "Accept Defer requests",
      category: "general",
      keywords: "defer accept defered",
      duration: "0:20",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Defer_Accept_Final.mp4"
    },
    {
      id: "defer-propose-sw",
      title: "Defer Propose SW",
      description: i18n.language === "mn" ? "接受延期请求并提出新的船舶周" : "Accept Defer requests and propose new ship week",
      placeholder: i18n.language === "mn" ? "接受延期请求，并安排新的发货周" : "Accept Defer request with new ship week",
      category: "general",
      keywords: "defer propose new sw shipweek defered",
      duration: "0:42",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Defer_Propose New SW_Revised.mp4"
    },
    {
      id: "defer-reject",
      title: "Defer Reject",
      description: i18n.language === "mn" ? "拒绝延期请求" : "Reject defer requests ",
      placeholder: i18n.language === "mn" ? "拒绝延期请求" : "Reject defer requests",
      category: "general",
      keywords: "defer reject defered",
      duration: "0:34",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/Defer_Reject_Final.mp4"
    },
    {
      id: "po-confirm-accept",
      title: "PO Confirm Accept",
      description: i18n.language === "mn" ? "接受采购订单确认" : "Accept purchase order confirmations",
      placeholder: i18n.language === "mn" ? "确认采购订单" : "Confirm purchase order",
      category: "general",
      keywords: "po confirm accept",
      duration: "0:25",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm Order_Accept_Revised.mp4"
    },
    {
      id: "po-confirm-change-price",
      title: "PO Confirm Change Price",
      description: i18n.language === "mn" ? "采购订单确认期间更改价格" : "Change price during PO confirmation",
      placeholder: i18n.language === "mn" ? "学习如何在采购订单确认期间更改价格" : "Learn to change price during PO confirmation",
      category: "general",
      keywords: "price change confirm",
      duration: "0:18",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm Order_Change Price_Revised.mp4"
    },
    {
      id: "po-confirm-change-qty",
      title: "PO Confirm Change Qty",
      description: i18n.language === "mn" ? "在采购订单确认期间更改数量" : "Change quantity during PO confirmation",
      placeholder: i18n.language === "mn" ? "在确认过程中修改订单数量" : "Modify order quantity during confirmation",
      category: "general",
      keywords: "quantity change confirm",
      duration: "0:38",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm Order_Change Qty_Final.mp4"
    },
    {
      id: "po-confirm-change-sw",
      title: "PO Confirm Change SW",
      description: i18n.language === "mn" ? "在采购订单确认期间修改发货周" : "Modify ship week during PO confirmation",
      placeholder: i18n.language === "mn" ? "在采购订单确认期间更改发货周" : "Change ship week during PO confirmation",
      category: "general",
      keywords: "ship week confirm",
      duration: "0:38",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Confirm Order_Change SW_Final.mp4"
    },
    {
      id: "po-reconfirm-accept",
      title: "PO ReConfirm Accept",
      description: i18n.language === "mn" ? "接受采购订单重新确认请求" : "Accept PO reconfirmation requests",
      placeholder: i18n.language === "mn" ? "接受并完成采购订单复确认" : "Accept and complete PO reconfirmations",
      category: "general",
      keywords: "reconfirm accept",
      duration: "0:19",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO ReConfirm Order_Accept_Final.mp4"
    },
    {
      id: "po-reconfirm-change",
      title: "PO ReConfirm Change",
      description: i18n.language === "mn" ? "在重新确认期间修改采购订单" : "Modify PO during reconfirmation",
      placeholder: i18n.language === "mn" ? "在采购订单重新确认期间进行更改" : "Make changes during PO reconfirmation",
      category: "general",
      keywords: "reconfirm change",
      duration: "0:35",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO ReConfirm Order_Change_Final.mp4"
    },
    {
      id: "po-bulk-upload-defer",
      title: "Defer Orders",
      description: i18n.language === "mn" ? "批量上传延迟订单" : "Bulk Upload Defer Orders",
      placeholder: i18n.language === "mn" ? "批量上传延迟订单" : "Bulk Upload Defer Orders",
      category: "bulkUpload",
      keywords: "defer bulkupload",
      duration: "1:47",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_Defer Orders_Revised.mp4"
    },
    {
      id: "po-bulk-upload-delay",
      title: "Delay Orders",
      description: i18n.language === "mn" ? "批量上传延迟订单" : "Bulk Upload Delay Orders",
      placeholder: i18n.language === "mn" ? "批量上传延迟订单" : "Bulk Upload Delay Orders",
      category: "bulkUpload",
      keywords: "delay bulkupload",
      duration: "1:56",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_Delay Orders_Revised.mp4"
    },
    {
      id: "po-bulk-upload-defer",
      title: "Divert Orders",
      description: i18n.language === "mn" ? "批量上传重定向订单" : "Bulk Upload Divert Orders",
      placeholder: i18n.language === "mn" ? "批量上传重定向订单" : "Bulk Upload Divert Orders",
      category: "bulkUpload",
      keywords: "divert bulkupload",
      duration: "0:52",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_Divert_Final.mp4"
    },
    {
      id: "po-bulk-upload-expedite",
      title: "Expedite Orders",
      description: i18n.language === "mn" ? "批量上传加急订单" : "Bulk Upload Expedite Orders",
      placeholder: i18n.language === "mn" ? "批量上传延批量上传加急订单迟订单" : "Bulk Upload Expedite Orders",
      category: "bulkUpload",
      keywords: "expedite bulkupload",
      duration: "1:42",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_Expedite Orders_Revised.mp4"
    },
    {
      id: "po-bulk-upload-confirm",
      title: "All Orders",
      description: i18n.language === "mn" ? "批量上传所有类型的订单" : "Bulk Upload All type of  Orders",
      placeholder: i18n.language === "mn" ? "批量上传所有类型的订单" : "Bulk Upload All type of Orders",
      category: "bulkUpload",
      keywords: "confirm bulkupload",
      duration: "2:04",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_PO Confirmation_Revised.mp4"
    },
    {
      id: "po-bulk-upload-reconfirm",
      title: "Reconfirm Orders",
      description: i18n.language === "mn" ? "批量上传重新确认订单" : "Bulk Upload Reconfirm Orders",
      placeholder: i18n.language === "mn" ? "批量上传重新确认订单" : "Bulk Upload Reconfirm Orders",
      category: "bulkUpload",
      keywords: "Reconfirm bulkupload",
      duration: "1:18",
      videoUrl: "https://objectstorage.us-phoenix-1.oraclecloud.com/p/dhHBI933wvoTG4JjfOmoXdNl15cZTss33Bx4DYPHXpZ0-onoTIFzld6KwIonF2AY/n/axquqanyfr3r/b/POConnect_Training_Videos/o/PO Bulk Upload_PO ReConfirm Order_Final.mp4"
    }
  ]), [i18n.language])

  const USER_GUIDES = {
    buyer: 'https://axquqanyfr3r.objectstorage.us-phoenix-1.oci.customer-oci.com/p/s_Rbthzn0Z7mFj-0i1j2PGQ6sO8lPVzjEfgrpRRM8HrfrNVzr4lkEQUobmffNC4Y/n/axquqanyfr3r/b/POConnect_User_Guides/o/PO_Connect_Buyer_User_Guide.pdf',
    vendor: 'https://axquqanyfr3r.objectstorage.us-phoenix-1.oci.customer-oci.com/p/s_Rbthzn0Z7mFj-0i1j2PGQ6sO8lPVzjEfgrpRRM8HrfrNVzr4lkEQUobmffNC4Y/n/axquqanyfr3r/b/POConnect_User_Guides/o/PO_Connect_Vendor_User_Guide.pdf',
    vendorSimplifiedChineseUserGuide: 'https://axquqanyfr3r.objectstorage.us-phoenix-1.oci.customer-oci.com/p/s_Rbthzn0Z7mFj-0i1j2PGQ6sO8lPVzjEfgrpRRM8HrfrNVzr4lkEQUobmffNC4Y/n/axquqanyfr3r/b/POConnect_User_Guides/o/PO Connect Vendor User Guide Simplified Chinese.pdf',
    vendorTraditionalChineseUserGuide: 'https://axquqanyfr3r.objectstorage.us-phoenix-1.oci.customer-oci.com/p/s_Rbthzn0Z7mFj-0i1j2PGQ6sO8lPVzjEfgrpRRM8HrfrNVzr4lkEQUobmffNC4Y/n/axquqanyfr3r/b/POConnect_User_Guides/o/PO Connect Vendor User Guide Traditional Chinese.pdf'
  };
  
  const filteredVideos = useMemo(() => {
    return videosData.filter((v) => {
      const matchesText =
        v.title.toLowerCase().includes(search) ||
        v.keywords.toLowerCase().includes(search);

      const matchesCategory = category === "all" || v.category === category;

      return matchesText && matchesCategory;
    });
  }, [search, category, videosData]);

  const groupedVideos = useMemo(() => {
    const grouped = {};
    filteredVideos.forEach((v) => {
      if (!grouped[v.category]) grouped[v.category] = [];
      grouped[v.category].push(v);
    });
    return grouped;
  }, [filteredVideos]);
  const user = JSON.parse(localStorage.getItem('userData'))

  return (
    <>
      <VideoModal
        open={Boolean(activeVideo)}
        videoUrl={activeVideo}
        onClose={() => setActiveVideo(null)}
      />

      <header className="bg-white border-b shadow-sm">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-semibold text-gray-800">
            {HelpTrainingVideos}
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            {LearnVideoGuide}
          </p>
        </div>
      </header>
      <div className="mb-8 mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
          <svg
            className="w-7 h-7 mr-2 text-blue-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          {LookingForHelp}
        </h2>

        <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* User Manual */}
            <div className="flex items-start p-4 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
              <svg
                className="w-8 h-8 text-blue-600 mr-3 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>

              <div>
                <h3 className="font-semibold text-gray-800 mb-1">{UserManual}</h3>
                <p className="text-sm text-gray-600 mb-2">
                  {DetailedInfo}
                </p>
                {/* {i18n.language !== "mn"  ? */}
                {(( user?.roleName === "BUYER_ROLE") || (i18n.language !== "mn"&&user?.roleName === "SUPPLIER_ROLE")) && <a
                  onClick={() => window.open(user?.roleName === "BUYER_ROLE" ? USER_GUIDES?.buyer : USER_GUIDES?.vendor, '_blank')}
                  // href="#"
                  className="inline-flex cursor-pointer items-center text-blue-600 hover:text-blue-700 font-medium text-sm"
                >
                  {AccessUserManual}
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>}
                {/* : */}
                {i18n.language === "mn" && (user?.roleName === "SUPPLIER_ROLE")&&<div className="flex flex-col gap-[2px]">
                  <a
                  onClick={() => window.open(user?.roleName === "BUYER_ROLE" ? USER_GUIDES?.buyer : USER_GUIDES?.vendorSimplifiedChineseUserGuide, '_blank')}
                  // href="#"
                    className="inline-flex cursor-pointer items-center text-blue-600 hover:text-blue-700 font-medium text-sm"
                  >
                    {AccessUserManual} {" 简体中文"}
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                  <a
                  onClick={() => window.open(user?.roleName === "BUYER_ROLE" ? USER_GUIDES?.buyer : USER_GUIDES?.vendorTraditionalChineseUserGuide, '_blank')}
                  // href="#"
                    className="inline-flex cursor-pointer items-center text-blue-600 hover:text-blue-700 font-medium text-sm"
                  >
                    {AccessUserManual} {" 繁体中文"}
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </div>}
                {/* } */}
              </div>
            </div>

            {/* Support */}
            <div className="flex items-start p-4 bg-green-50 rounded-lg hover:bg-green-100 transition-colors">
              <svg
                className="w-8 h-8 text-green-600 mr-3 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>

              <div>
                <h3 className="font-semibold text-gray-800 mb-1">{NeedHelp}</h3>
                <p className="text-sm text-gray-600 mb-2">
                  {HaveQuestions}
                </p>
                <a
                  href="mailto:poconnectsupport@harborfreight.com"
                  className="inline-flex items-center text-green-600 hover:text-green-700 font-medium text-sm"
                >
                  poconnectsupport@harborfreight.com
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-0">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
          <svg
            className="w-7 h-7 mr-2 text-purple-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
          {TrainingVideo}
        </h2>
      </div>

      <div className="container mx-auto px-6 py-8">
        <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
          <div className="flex flex-col md:flex-row gap-4">
            <input
              type="text"
              placeholder={searchVideos}
              className="flex-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              value={search}
              onChange={(e) => setSearch(e.target.value.toLowerCase())}
            />

            <select
              className="md:w-64 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="all">{AllCategories}</option>
              {Object.entries(categoryConfig).map(([key, cfg]) => (
                <option key={key} value={key}>
                  {cfg.title}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-3 text-sm text-gray-600">
            {Showing} {filteredVideos.length} {videos}
          </div>
        </div>

        <div className="space-y-10">
          {Object.entries(groupedVideos)
            .sort(
              (a, b) =>
                categoryConfig[a[0]].order - categoryConfig[b[0]].order
            )
            .map(([categoryKey, items]) => (
              <CategorySection
                key={categoryKey}
                categoryKey={categoryKey}
                videos={items}
                onPlay={setActiveVideo}
              />
            ))}
        </div>
      </div>
    </>
  );
}
